import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router";
import { Provider } from "react-redux";
import createStore from "./store";
import routes from "./routes";
import { history } from "./history";

const store = createStore(window.__INITIAL_STATE__);

Array.prototype.last = function() {
  return this[this.length - 1];
};

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} routes={routes} />
  </Provider>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js